<template>
  <div class="visa-detail bg-white">
    <h3>{{ detail.visaName }}</h3>
    <van-row class="mt5">
      <van-col span="13">
        <label>办理地点</label>
        {{ detail.cityName }}
      </van-col>
      <van-col span="11">
        <label>工作日</label>
        {{ detail.visaWeekDay }}
      </van-col>
    </van-row>
    <van-row class="mt5">
      <van-col span="13">
        <label>停留天数</label>
        {{ detail.retentionperiod }}
      </van-col>
      <van-col span="11">
        <label>{{ $t('Q214','有效期') }}</label>
        {{ detail.expiryDate }}
      </van-col>
    </van-row>
    <van-row class="mt5">
      <van-col
        v-if="!detail.id"
        span="13"
      >
        <label>申请提交</label>
        {{ detail.interview }}
      </van-col>
      <van-col span="11">
        <label>入境数</label>
        {{ detail.immigrationNo }}
      </van-col>
    </van-row>
    <van-row
      v-if="!detail.id"
      class="mt5"
    >
      <label>受理范围</label>
      {{ detail.provinceName }}
    </van-row>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  created () {
  }
}
</script>

<style lang="less">
.visa-detail {
  padding: 8px;

  label {
    color: @color-text-gray;
  }
}
</style>
